module.exports = __webpack_public_path__ + "static/media/shreeombuildcon.4a9fc64d.jpg";